import React from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';

// COMPONENTS
// import CopyRights from '../components/CopyRights';

// COMMON
import LoginScreen from '../screens/common/auth/LoginScreen';
import RegisterScreen from '../screens/common/auth/RegisterScreen';
import HomeScreen from '../screens/common/HomeScreen';
import CartScreen from '../screens/common/CartScreen';
import ProductScreen from '../screens/common/ProductScreen';
import ShippingScreen from '../screens/common/ShippingScreen';
import PaymentScreen from '../screens/common/PaymentScreen';
import PlaceOrderScreen from '../screens/common/PlaceOrderScreen';
import OrderScreen from '../screens/common/OrderScreen';
import ContactScreen from '../screens/common/ContactScreen';

// USER 
import UserOrderListScreen from '../screens/client/UserOrderListScreen';
import UserProfileUpdateScreen from '../screens/client/UserProfileUpdateScreen';

// ADMIN
import AdminDashboard from '../screens/admin/AdminDashboard';
import ProductsListScreen from '../screens/admin/ProductsListScreen';
import UserListScreen from '../screens/admin/UserListScreen';
import MakerListScreen from '../screens/admin/MakerListScreen';
import OrderListScreen from '../screens/admin/OrderListScreen';
import AdminProfileScreen from '../screens/admin/AdminProfileScreen';
import AdminOrderScreen from '../screens/admin/AdminOrderScreen';
import ProfileUpdateScreen from '../screens/admin/ProfileUpdateScreen';
import ProductDetailsScreen from '../screens/admin/ProductDetailsScreen';
import ProductAddedScreen from '../screens/admin/ProductAddedScreen';

// MAKER -> ARTISAN
import ArtisanDashboard from '../screens/artisan/ArtisanDashboard';
import ArtisanProfileScreen from '../screens/artisan/ArtisanProfileScreen';
import ArtisanProductListScreen from '../screens/artisan/ArtisanProductListScreen';
import ArtisanOrderListScreen from '../screens/artisan/ArtisanOrderListScreen';
import ArtisanAddedProductScreen from '../screens/artisan/ArtisanAddedProductScreen';

// AUTH 
import RouterLayout from './auth/RouterLayout';
import RequireAuth from './auth/RequireAuth';

// PAGES
import NotFoundPage from './pages/NotFoundPage';
import UnAuthorizedPage from './pages/UnAuthorizedPage';
import ArtisanProductDetailsScreen from '../screens/artisan/ArtisanProductDetailsScreen';
import ArtisanProductsScreen from '../screens/admin/ArtisanProductsScreen';
import ArtisanProductDScreen from '../screens/admin/ArtisanProductDScreen';
import BlogScreen from '../screens/common/BlogScreen';
import UserReportScreen from '../screens/admin/UserReportScreen';
import MapScreen from '../screens/common/MapScreen';
import UserReportDetailScreen from '../screens/admin/UserReportDetailScreen';
import ProductFilterScreen from '../screens/common/ProductFilterScreen';
import ArtisanOrderDetailsScreen from '../screens/artisan/ArtisanOrderDetailsScreen';
import ArtisanOrderScreen from '../screens/artisan/ArtisanOrderScreen';
import ArtisanRegisterScreen from '../screens/common/auth/ArtisanRegisterScreen';
import Invoice from '../screens/client/Invoice';
import AdminListScreen from '../screens/admin/AdminListScreen';






const Router = () => {

    return (
        <HashRouter>
            <Routes>
                <Route path='/' element={ <RouterLayout /> } >

                    {/* COMMON */}
                    <Route path='/' element={<HomeScreen /> } />
                    <Route path='login' element={<LoginScreen /> } />
                    <Route path='register' element={<RegisterScreen /> } />
                    <Route path='artisan/register' element={ <ArtisanRegisterScreen /> } />
                    <Route path='product/:id' element={ <ProductScreen /> } />
                    <Route path='product/filter' element={ <ProductFilterScreen /> } />
                    <Route path='cart' element={<CartScreen /> } />
                    <Route path='cart/:productId' element={<CartScreen /> } />
                    <Route path='/shipping' element={<ShippingScreen /> } />
                    <Route path='/payment' element={<PaymentScreen /> } />
                    <Route path='/placeorder' element={<PlaceOrderScreen /> } />
                    <Route path='/orderList' element={<UserOrderListScreen /> } />
                    <Route path='/order/:orderId' element={<OrderScreen /> } />
                    <Route path='/profile' element={<UserProfileUpdateScreen /> } />
                    <Route path='/blog' element={ <BlogScreen /> } />
                    <Route path='/contact' element={ <ContactScreen /> } />
                    <Route path='/map' element={ <MapScreen /> } />
                    <Route path='/invoice/:id' element={ <Invoice /> } />
                
                
                    {/* AUTH */}
                    <Route path='unAuth' element={<UnAuthorizedPage /> } />


                    {/* ADMIN */}
                    <Route element={ <RequireAuth allowRoles={'admin'} /> } >
                        <Route path='admin/dashboard' element={ <AdminDashboard /> } /> 
                        <Route path='admin/userList' element={ <UserListScreen /> } />
                        <Route path='admin/adminList' element={ <AdminListScreen /> } />
                        <Route path='admin/productList' element={ <ProductsListScreen /> } />
                        <Route path='admin/makerList' element={ <MakerListScreen /> } />
                        <Route path='admin/profile' element={ <AdminProfileScreen /> } />
                        <Route path='admin/order' element={ <AdminOrderScreen /> } />
                        <Route path='admin/orderList' element={ <OrderListScreen /> } />
                        <Route path='admin/update/:id' element={ <ProfileUpdateScreen /> } />
                        <Route path='admin/product/view/:id' element={ <ProductDetailsScreen /> } />
                        <Route path='admin/new/product' element={ <ProductAddedScreen /> } />
                        <Route path='admin/artisan/product' element={ <ArtisanProductsScreen /> } />
                        <Route path='admin/artisan/product/:id' element={ <ArtisanProductDScreen /> } />
                        <Route path='admin/report' element={ <UserReportScreen /> } />
                        <Route path='admin/report/:id' element={ <UserReportDetailScreen /> } />
                    </Route>


                    {/* MAKER  */}
                    <Route element={<RequireAuth allowRoles={'artisan'} /> }>
                        <Route path='artisan/dashboard' element={ <ArtisanDashboard /> } />
                        <Route path='artisan/profile' element={< ArtisanProfileScreen /> } />
                        <Route path='artisan/order' element={< ArtisanOrderScreen /> } />
                        <Route path='artisan/productList' element={ <ArtisanProductListScreen /> } />
                        <Route path='artisan/orderList' element={ <ArtisanOrderListScreen /> } />
                        <Route path='artisan/order/:id' element={ <ArtisanOrderDetailsScreen /> } />
                        <Route path='artisan/new/product' element={ <ArtisanAddedProductScreen /> } />
                        <Route path='artisan/product/view/:id' element={ <ArtisanProductDetailsScreen /> } />
                    </Route>


                    {/* NOT FOUND PAGE */}
                    <Route path='*' element={ <NotFoundPage /> } />

                </Route>
            </Routes>
            {/* <CopyRights /> */}
        </HashRouter>
    )
}

export default Router;
